import React from "react";
import PropTypes from "prop-types";
import { Pagination } from "react-bootstrap";

function ScreenSelectPagination(props) {
  const maxDisplayedButtons = 5;

  let first =
    props.activeScreen + Math.ceil(maxDisplayedButtons / 2) <= props.numberOfScreens
      ? Math.max(0, props.activeScreen - Math.floor(maxDisplayedButtons / 2))
      : props.numberOfScreens - maxDisplayedButtons;
  let last =
    props.activeScreen - Math.floor(maxDisplayedButtons / 2) >= 0
      ? Math.min(props.numberOfScreens, props.activeScreen + Math.ceil(maxDisplayedButtons / 2))
      : maxDisplayedButtons;

  const numbersToDisplay = [...Array(props.numberOfScreens).keys()].slice(first, last);

  return (
    <>
      {props.numberOfScreens > maxDisplayedButtons &&
      props.activeScreen > maxDisplayedButtons / 2 ? (
        <Pagination.Item disabled>...</Pagination.Item>
      ) : null}
      {numbersToDisplay.map(i => (
        <Pagination.Item
          active={i === props.activeScreen}
          key={i}
          onClick={() => props.setDisplayedScreen(i)}
          data-value={i}
        >
          {i + 1}
        </Pagination.Item>
      ))}
      {props.numberOfScreens > maxDisplayedButtons &&
      props.activeScreen < props.numberOfScreens - maxDisplayedButtons / 2 ? (
        <Pagination.Item disabled>...</Pagination.Item>
      ) : null}
    </>
  );
}

ScreenSelectPagination.propTypes = {
  activeScreen: PropTypes.number.isRequired,
  numberOfScreens: PropTypes.number.isRequired,
  setDisplayedScreen: PropTypes.func.isRequired
};

export default ScreenSelectPagination;
